// buildPath.js
import {routes} from './index';

export const buildPath = (routeKey, lang) => {
    if (!routes[routeKey][lang]) {
        return;
    }
    return `/${lang}/${routes[routeKey][lang]}`;
}
